import React from 'react'
import { Typography } from 'antd';
const { Title, Paragraph, Text } = Typography;

export default function Landscapeadd() {
    return (
    <Typography>
      <Title level={2}>介绍</Title>
      <Paragraph>
        布置景观通过软件内置的大量3D景观模型、2D图片素材和软件提供的各种景观布置操作，对道路及周边进行三维绿化布置，丰富道路场景。
        景观共有<Text mark>乔木、灌木、花卉、地被、车辆、行人、路灯、标志标线、道路设施、建筑环境</Text>等大类，各大类均包含大量模型供选取，进入各
        大类的按钮位于景观选取列表界面上方。此外模型按精度分为2D、3D和高精3D，用户根据实际情况选取，建议尽可能多用2D素材，少用高精3D，
        精度模型的分类按钮位于景观选取列表界面下方。
      </Paragraph>
      <Paragraph>
        景观布置的方式包括<Text strong>单个布置、线性布置、区域布置和智能布置</Text>，各布置的操作方式位于主界面下方区域。
      </Paragraph>
      <Title level={2}>单个布置方式</Title>
      <Paragraph>
      <Text strong>单个布置</Text>顾名思义，就是一个一个地选择位置布置景观。点击主界面下方点布置按钮，弹出景观选取列表界面，选择要布置的景观模型，然后景观模型会一直跟随鼠标移动，直至点击鼠标左键添加一个景观或者
        点击鼠标右键取消本次布置。每次进行布置时会默认使用上一次选取的景观，所以如果要使用上一次的景观，只需右键关掉景观选取界面即可，无需再去选取。
      </Paragraph>
      <Title level={2}>线性布置和区域布置方式</Title>
      <Paragraph>
      <Text strong>线性布置</Text>是用户自定义路径，然后程序根据间距等参数沿路径布置景观的方式，<Text strong>区域布置</Text>是用户自定义边界，然后程序根据间距等参数在边界内布置景观的方式。
        点击主界面下方线布置和面布置按钮，弹出景观选取列表界面，选择要布置的景观模型，这时与单个布置方式不同，不会出现景观模型跟随
        鼠标移动的场景，而是进入路径描边操作。用户需要先用鼠标左键点击确定路径的各个顶点，描边的过程中会有红色线条跟随，让用户可以实时的观看所描的路径形状。当确认
        路径描边完成时，点击鼠标右键，代表本次路径完成，这时才会显示所要添加的景观。点击鼠标右键表示本次路径布置完成，但并没有退出线性布置和区域布置状态，用户仍可以继续
        点击鼠标左键进行下一次的路径描边布置新的线性景观，而无需点击主界面下方按钮。只有当完成一次路径布置时，再右键一次才会退出线性布置和区域布置状态回到常规状态。
      </Paragraph>
      <Title level={2}>智能布置方式</Title>
      <Text strong>智能布置</Text>是根据已有的线性模型，自动选取该线性模型的路由作为参照进行偏移布置的方式。首先选择一个已有的线性模型，然后点击主界面下方的智能布置，弹出景观选取列表界面，
      选择要布置的景观模型，会生成一个平行于所选模型的线性模型，并跟随鼠标移动，用户点击鼠标左键确认生成，点击鼠标右键取消本次布置。
    </Typography>
  )
}